import { useUserConfig } from '@/store/user-config';
import { computed } from 'vue';

export type AdminPageVisibility = { isAllSelected: boolean; except: string[] };

export const isAdminPageVisible = (visibility: AdminPageVisibility, page: string) =>
  visibility.isAllSelected ? !visibility.except.includes(page) : visibility.except.includes(page);

export const parseAdminPageVisibility = (value?: string): AdminPageVisibility =>
  value === undefined ? { isAllSelected: true, except: [] } : JSON.parse(value);

export const adminPageVisibilityKey = 'settings--admin--visiblePages';

export const useAdminPageVisibility = computed(() => {
  const visibility = useUserConfig().settings?.admin?.visiblePages;
  return parseAdminPageVisibility(visibility);
});
